import React from 'react';
import { Box, Button, CircularProgress, lighten, Tooltip, useTheme } from '@mui/material';
import { FaOptionIcon } from '@europrocurement/l2d-icons';
import { useDossierFormulaireContext } from '@europrocurement/l2d-modules';

export type DossierValidationActionsProps = {
    onCancel?: () => void;
    onSendMessage?: () => void;
    onValidate?: () => void;
};

const DossierValidationActions: React.FunctionComponent<DossierValidationActionsProps> = function (
    props,
) {
    const { hasNonPersistedChanges, processing } = useDossierFormulaireContext();
    const { onCancel, onSendMessage, onValidate } = props;
    const { palette } = useTheme();

    const btnSx = {
        padding: '16px 24px',
        minWidth: 'auto',
        lineHeight: '24px',
    };

    const textBtnSx = {
        ...btnSx,
        color: palette.primary.dark,
        '&:hover': {
            color: lighten(palette.primary.dark, 0.2),
        },
    };

    const primaryBtnSx = {
        ...btnSx,
        backgroundColor: palette.primary.dark,
        display: 'flex',
        alignItems: 'center',
        gap: '0 10px',
        '&:hover': {
            backgroundColor: lighten(palette.primary.dark, 0.2),
        },
    };

    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'center',
                gap: '24px',
                paddingTop: '1em',
                flexWrap: 'wrap',
                position: 'sticky',
                bottom: 0,
                right: 0,
                backgroundColor: palette.background.paper,
            }}
        >
            {onCancel && (
                <Tooltip
                    title={!hasNonPersistedChanges ? "Rien n'a été modifié" : ''}
                    arrow
                    placement="top"
                >
                    {/* Box required for the use of tooltip */}
                    <Box>
                        <Button
                            variant="text"
                            sx={textBtnSx}
                            onClick={onCancel}
                            disabled={!hasNonPersistedChanges}
                            role="button"
                        >
                            Annuler
                        </Button>
                    </Box>
                </Tooltip>
            )}
            {onSendMessage && (
                <Button
                    variant="contained"
                    sx={primaryBtnSx}
                    onClick={onSendMessage}
                >
                    <FaOptionIcon
                        sx={{ lineHeight: 0 }}
                        icon={['fas', 'paper-plane']}
                    />
                    Demander
                </Button>
            )}

            {onValidate && (
                <Button
                    variant="contained"
                    sx={primaryBtnSx}
                    onClick={onValidate}
                    disabled={processing}
                >
                    {processing && (
                        <CircularProgress
                            color="inherit"
                            size="16px"
                        />
                    )}
                    <FaOptionIcon
                        sx={{ lineHeight: 0 }}
                        icon={['fas', 'save']}
                    />
                    Sauvegarder
                </Button>
            )}
        </Box>
    );
};

export default DossierValidationActions;
